import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { closeAllModals } from '../actions/modalActions';

import SessionDetails from './SessionDetails';

export default connect((state) => ({
  id: state.modals.data,
  open: state.modals.session,
}))(
  class SessionModal extends Component {
    state = {};

    close = () => {
      this.props.dispatch(closeAllModals());
    };

    render() {
      const { id, open, dispatch } = this.props;
      return (
        <div>
          <Modal size="lg" isOpen={open} toggle={this.close}>
            <ModalHeader toggle={this.close}>Session Details</ModalHeader>
            <ModalBody>
              <SessionDetails dispatch={dispatch} id={id} />
            </ModalBody>
            <ModalFooter />
          </Modal>
        </div>
      );
    }
  }
);
